import Vue from 'vue'
 
//server JURU
// export const  URL_BASE=process.env.NODE_ENV === 'production' ? "/juru/api/" : "https://telemartin.com/juru/api/";
// export const  URL_WEB=process.env.NODE_ENV === 'production' ? "/juru/" :"https://telemartin.com/juru/";
export const  URL_BASE=process.env.NODE_ENV === 'production' ? "/api/" : "https://certificadosdegasperu.com/api/";
export const  URL_WEB=process.env.NODE_ENV === 'production' ? "/" :"https://certificadosdegasperu.com/";

//SERVER UDH
//export const  URL_BASE=process.env.NODE_ENV === 'production' ? "/api/" : "https://prueba231.cloududh.com/api/";
//export const  URL_WEB=process.env.NODE_ENV === 'production' ? "/" : "https://prueba231.cloududh.com/";
//////////////////////////////////////
// export const  URL_IMG= process.env.NODE_ENV === 'production' ?   "/juru/app/":"/juru/";
export const  URL_IMG= process.env.NODE_ENV === 'production' ?   "/app/":"/";
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.mixin({
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
 
  created() {
     // Listen for our custom event from the SW registration
     document.addEventListener('swUpdated', this.updateAvailable, {
      once: true
    })

    // // // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange',  () => {
      if (this.refreshing) return
      this.refreshing = true
      // //   // Here the actual reload of the page occurs
      window.location.reload(true)
    });
    ///fin service worker
    //si se desea que el metodo inicie inmediatamente recuerda poner opciones para inicializarlos;
    var myId = this.$options.id;
    if (myId) {
      // console.log("info desde el global mixin");
      this.inputValidoInvalido(myId);
    }
  },
  //metodos globales
  methods: {
    updateAvailable(event) {
      // console.log(event)
      this.registration = event.detail
      this.updateExists = true
    },
    refreshApp() {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({
        type: 'SKIP_WAITING'
      })
    },
    URL_BASE() {
      return URL_BASE;
    },
    URL_WEB() {
      return URL_WEB;
    },
    URL_IMG() {
      return URL_IMG;
    },
    notificacion(type, titulo, text, group = "") {
      this.$notify({
        group,
        title: titulo,
        text,
        type,
      })
    },
 obtenerNumeroFormateado(num) {
      return num.toString().padStart(6, "0"); // Completa con ceros hasta 6 dígitos
    },
    advertencia(text) {
      this.notificacion('warn', "<h5><b> <i class='fas fa-exclamation-circle fa-lg'></i>  ¡Advertencia!</b></h5>", "<h6>" + text + "</h6>");
    },
    exito(text) {
      this.notificacion('success', "<h5><b> <i class='fas fa-check fa-lg'></i>  ¡Exito!</b></h5>", "<h6>" + text + "</h6>");
    },
    error(text) {
      this.notificacion('error', "<h5><b> <i class='fas fa-exclamation-triangle fa-lg'></i>  ¡ ERROR !</b></h5>", "<h6>" + text + "</h6>");
    },
    informacion(text) {
      this.notificacion('', " <h5 class='text-center'><b> <i class='fas fa-info-circle fa-lg'></i>  AVISO</b></h5>", "<h6 class='text-center'>" + text + "</h6>", "info");
    },
    verificandoToken() {
      if (this.$store.state.auth) {
        // setTimeout(() => {

        // }, 5000); 
        console.log("tokena a espirar");
        setInterval(() => {
          alert('token a punto de caducar');
        }, 5000);
        //3 segundo
      }

    },
    procesoCompletado() {
      this.$swal('Proceso completado', '', 'success')
    },

    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    fechaActual(fechaIngles = false) {
      let date = new Date()
      let day = `${(date.getDate())}`.padStart(2, '0');
      let month = `${(date.getMonth()+1)}`.padStart(2, '0');
      let year = date.getFullYear();
      if (fechaIngles) {
        return `${year}-${month}-${day}`;
      } else {
        return `${day}-${month}-${year}`;
      }

    },
    sumarDias(fechaInput, dias) {
      var fecha = new Date(fechaInput);
      fecha.setDate(fecha.getDate() + dias);

      let day = `${(fecha.getDate())}`.padStart(2, '0');
      let month = `${(fecha.getMonth()+1)}`.padStart(2, '0');
      let year = fecha.getFullYear();

      return `${year}-${month}-${day}`;

    }

  },

});